export default "__VITE_ASSET__BcTRfdxT__"